import React from "react";
import { Container, Divider, Typography, Box, IconButton } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import CloseIcon from "@mui/icons-material/Close";

const styles = theme => ({
  "@global": {
    '[class*="MuiTabs-root"]': {
      borderTop: "none"
    }
  },
  title: {
    textAlign: "left",
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    }
  },
  root: {
    paddingBottom: theme.spacing(4),
    minHeight: `calc(100vh - ${theme.sizes.topNavBarHeight}px)`,
    display: "flex",
    flexDirection: "column"
  },
  close: {
    position: "absolute",
    right: "-20px",
    top: "-40px",
    color: theme.palette.grey[500]
  }
});

function FullPageLayout(props) {
  const { classes, title, headerActions, children, onCloseClick } = props;

  return (
    <Container maxWidth="xl" className={classes.root}>
      <Box
        display="flex"
        position="relative"
        flexDirection={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
        mt={4}
      >
        {title && (
          <Box mb={3}>
            <Typography
              variant="h2"
              color="textSecondary"
              className={classes.title}
            >
              {title}
            </Typography>
          </Box>
        )}
        {!!headerActions && <Box mb={3}>{headerActions}</Box>}
        {onCloseClick && (
          <IconButton
            aria-label="close"
            className={classes.close}
            onClick={onCloseClick}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <Divider />
      {children}
    </Container>
  );
}

export default withStyles(styles)(FullPageLayout);
